// Componentes personalizados
import React from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import BlocoTituloTextoBotaoImagem from "../../components/BlocoTituloTextoBotaoImagem";
import { BotaoFaleConosco } from "../../components/Botoes";
import NumerosDaSifat from "../../components/NumerosDaSifat";
import NossasSolucoes from "../../components/NossasSolucoes";
import TecnologiasOferecidas from "../../components/TecnologiasOferecidas";
import SecaoPagina from "../../components/SecaoPagina";
import PageLayout from "../../layouts/PageLayout";
// Imagens
import CelularMonitorTrans from "../../assets/imagens/CelularMonitorTrans.webp";
import FundoCinzaDegrade from "../../assets/imagens/FundoCinzaDegrade.webp";
import FundoAzul from "../../assets/imagens/FundoAzulComLogo.jpg";
import FundoCinza from "../../assets/imagens/FundoCinzaDegradeHorizontal.jpg";

const ContainerBling = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 300px);
  padding: 2rem;
`;

const ConteudoCentralizado = styled.div`
  text-align: center;
  max-width: 600px;
  padding: 3rem;
  border-radius: 8px;
  background: #f5f5f5;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Titulo = styled.h1`
  color: #333;
  font-size: 2rem;
  margin-bottom: 2rem;
  font-weight: 600;
`;

const Mensagem = styled.p`
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const CodigoContainer = styled.div`
  background: white;
  border: 2px solid #007bff;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 2rem 0;
  word-break: break-all;
`;

const CodigoTexto = styled.p`
  color: #007bff;
  font-size: 1.3rem;
  font-weight: 600;
  font-family: "Courier New", monospace;
  margin: 0;
`;

const BotaoCopiar = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 1rem;

  &:hover {
    background-color: #0056b3;
  }

  &:active {
    background-color: #003f8f;
  }
`;

const MensagemCopia = styled.p`
  color: #28a745;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  display: ${(props) => (props.$visivel ? "block" : "none")};
`;

export default function Home() {
  const [searchParams] = useSearchParams();
  const codigo = searchParams.get("code");
  const [copiado, setCopiado] = React.useState(false);

  const handleCopiar = () => {
    if (codigo) {
      navigator.clipboard.writeText(codigo);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    }
  };

  if (codigo) {
    return (
      <PageLayout>
        <ContainerBling>
          <ConteudoCentralizado>
            <Titulo>✓ Sua sessão foi autorizada!</Titulo>
            <Mensagem>Copie o código abaixo e insira no E-sync</Mensagem>

            <CodigoContainer>
              <CodigoTexto>{codigo}</CodigoTexto>
            </CodigoContainer>
            <BotaoCopiar onClick={handleCopiar}>Copiar Código</BotaoCopiar>
            <MensagemCopia $visivel={copiado}>
              ✓ Código copiado para a área de transferência!
            </MensagemCopia>
          </ConteudoCentralizado>
        </ContainerBling>
      </PageLayout>
    );
  }
  return (
    <PageLayout>
      <SecaoPagina $bgimagem={FundoCinzaDegrade}>
        <BlocoTituloTextoBotaoImagem
          margemImagem={null}
          botao2={null}
          corParagrafo={null}
          corTitulo={null}
          paragrafo2={null}
          tituloTipoB={null}
          imagem={CelularMonitorTrans}
          max={"30em"}
          possuiLogosClientes={true}
          botao1={<BotaoFaleConosco />}
          paragrafo1={
            "Nossas soluções vão resolver seus problemas de gestão e automatizar vários processos, para que você possa ter mais qualidade de vida e tempo para si."
          }
          tituloTipoA={true}
          titulo1={"Há +30 anos oferecendo excelência em"}
          titulo2={"Sistemas de Gestão."}
        />
      </SecaoPagina>

      <SecaoPagina $bgimagem={FundoAzul} $gap={"4em"}>
        <NumerosDaSifat />
        <NossasSolucoes />
      </SecaoPagina>

      <SecaoPagina
        $bgimagem={FundoCinza}
        $paddingmin={"2em 2em 9em"}
        $paddingmid={"2em 2em 9em"}
        $paddingmax={"4em 4em 8em"}
      >
        <TecnologiasOferecidas />
      </SecaoPagina>
    </PageLayout>
  );
}
